<template>
  <div class="c-product-benefits__item">
    <div class="c-product-benefits__image">
      <i class="ico ico-truck"></i>
    </div>
    <span class="c-product-benefits__text">{{ shippingText }}</span>
  </div>
</template>

<script>
import { formatPrice } from "FrontendJsAssets/common/format"

export default {
  name: 'shipping-info',
  props: {
    initialData: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    freeLimit: null,
    freeAmount: null,
    productPrice: null,
    hasProductFreeShipping: null,
    isEmptyCart: false,
    texts: []
  }),
  created() {
    this.freeLimit = this.initialData.freeLimit
    this.freeAmount = this.initialData.freeAmount
    this.productPrice = this.initialData.productPrice
    this.hasProductFreeShipping = this.initialData.hasProductFreeShipping
    this.isEmptyCart = this.initialData.isEmptyCart
    this.texts = this.initialData.texts

    window.Event.on('Custom.Cart.addedItem', data => {
      this.updateData(data.response)
    })
    window.Event.on('Custom.Cart.updatedItem', data => {
      this.updateData(data.response)
    })
    window.Event.on('Custom.Cart.removedItem', data => {
      this.updateData(data.response)
    })
    window.Event.on('Cart.product.removed', data => {
      this.updateData(data)
    })
    window.Event.on('Cart.fetchedProducts', data => {
      this.updateData(data.response)
    })
    window.Event.on('Custom.Cart.fetchedTotals', data => {
      if (data.response.status) {
        this.freeAmount = data.response.data.free_shipping.free_shipping_amount
        this.isEmptyCart = data.response.data.totals.count <= 0
      }
    })
  },
  methods: {
    updateData(response) {
      if (!response.free_shipping) {
        return
      }

      this.freeAmount = response.free_shipping.price
      this.isEmptyCart = response.totals.quantity <= 0
    }
  },
  computed: {
    hasFreeShipping() {
      return this.hasProductFreeShipping || this.productPrice >= this.freeLimit
    },
    shippingText() {
      let textKey = ''

      if (this.hasFreeShipping) {
        textKey = this.freeAmount > 0 ? 'textProductFree' : 'textFree'
      }
      else if (this.isEmptyCart) {
        textKey = this.hasFreeShipping ? 'textProductFree' : 'textEmpty'
      }
      else {
        textKey = this.freeAmount > 0 ? 'text' : 'textFree'
      }

      return this.texts[textKey]
        .replace(':freeAmount', formatPrice(this.freeAmount))
        .replace(':freeLimit', formatPrice(this.freeLimit))
    }
  },
};
</script>